import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: ${theme.colors.surfaceContainerLowest};
    color: ${theme.colors.onSurface};
    padding: ${theme.spacing.level7};

    @media (max-width: 480px) {
      padding: ${theme.spacing.level5} ${theme.spacing.level4};
      justify-content: flex-start;
      padding-top: ${theme.spacing.level8};
    }
  `}
`;

export const Card = styled.div`
  ${({ theme }) => css`
    max-width: 480px;
    width: 100%;
    padding: ${theme.spacing.level8};
    border-radius: ${theme.borderRadius.large};
    border: 1px solid ${theme.colors.outline};
    background: ${theme.colors.surface};
    text-align: center;

    @media (max-width: 480px) {
      padding: ${theme.spacing.level6};
      border-radius: ${theme.borderRadius.medium};
    }
  `}
`;

export const OrgIcon = styled.div`
  ${({ theme }) => css`
    width: 64px;
    height: 64px;
    margin: 0 auto ${theme.spacing.level6};
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${theme.colors.primaryContainer};
    border-radius: ${theme.borderRadius.large};
    font-size: ${theme.font.headlineMedium.fontSize};
    font-weight: 700;
    color: ${theme.colors.onPrimaryContainer};
  `}
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    font-size: ${theme.font.headlineSmall.fontSize};
    font-weight: 700;
    margin: 0 0 ${theme.spacing.level4};
  `}
`;

export const Subtitle = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.font.bodyLarge.fontSize};
    color: ${theme.colors.onSurfaceVariant};
    margin: 0 0 ${theme.spacing.level6};
    line-height: 1.5;
  `}
`;

export const InviterText = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.font.bodyMedium.fontSize};
    color: ${theme.colors.onSurfaceVariant};
    margin: 0 0 ${theme.spacing.level7};
  `}
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.level4};
  justify-content: center;
  flex-wrap: wrap;
`;

export const PrimaryButton = styled.button`
  ${({ theme }) => css`
    padding: ${theme.spacing.level4} ${theme.spacing.level7};
    background: ${theme.colors.primary};
    color: ${theme.colors.onPrimary};
    border: none;
    border-radius: ${theme.borderRadius.small};
    font-size: ${theme.font.bodyMedium.fontSize};
    font-weight: 600;
    cursor: pointer;

    &:hover {
      opacity: 0.9;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `}
`;

export const SecondaryButton = styled(PrimaryButton)`
  ${({ theme }) => css`
    background: transparent;
    border: 1px solid ${theme.colors.outline};
    color: ${theme.colors.onSurface};
  `}
`;

export const ErrorText = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.error};
    font-size: ${theme.font.bodySmall.fontSize};
    margin: ${theme.spacing.level4} 0 0;
  `}
`;

export const SuccessText = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.primary};
    font-size: ${theme.font.bodyMedium.fontSize};
    margin: ${theme.spacing.level4} 0 0;
  `}
`;

export const WarningBox = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacing.level4} ${theme.spacing.level5};
    border-radius: ${theme.borderRadius.small};
    background: ${theme.colors.errorContainer};
    color: ${theme.colors.onErrorContainer};
    font-size: ${theme.font.bodySmall.fontSize};
    line-height: 1.5;
    margin: 0 0 ${theme.spacing.level6};
    text-align: left;

    strong {
      font-weight: 700;
    }
  `}
`;

export const EmailHighlight = styled.span`
  ${({ theme }) => css`
    font-weight: 600;
    color: ${theme.colors.primary};
  `}
`;

export const LinkText = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.font.bodyMedium.fontSize};
    margin: ${theme.spacing.level6} 0 0;

    a {
      color: ${theme.colors.primary};
      text-decoration: none;
      font-weight: 600;

      &:hover {
        text-decoration: underline;
      }
    }
  `}
`;
